
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/android/keep",
      function () {
        return require("private-next-pages/android/keep/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/android/keep"])
      });
    }
  